import React from 'react';

import { Button } from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

import ComponentWrapper from './ComponentWrapper';
import LoaderNew from './LoaderNew';

import { emojiesSuccess } from '../utils';

class PasswordRecoverAndAccountCreate extends ComponentWrapper {
  state = {
    email: '',
    password: '',
    verificationCode: '',
    emailConfirmed: false,
    passwordConfirmed: false,
    verificationConfirmed: false,
    passwordVisible: true,
    loading: false,
    message: '',
  }

  passwordRecoveryEmail = () => {
    const { email } = this.state;

    this.postWithData({
      url: `/rest/pass_recovery`,
      data: {
        email,
      },
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
            emailConfirmed: true,
          });
        }
      },
    });
  };

  createAccountEmailSend = () => {
    const { email } = this.state;

    this.postWithData({
      url: `/rest/request_pure_invite`,
      data: {
        email
      },
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
            message: data.message,
            emailConfirmed: true,
          });
        }
      },
    });
  };

  checkVerificationCode = () => {
    const { email, verificationCode } = this.state;

    this.postWithData({
      url: `/rest/check_verification_code`,
      data: {
        email,
        code: verificationCode
      },
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
            emailConfirmed: true,
            verificationConfirmed: true,
          });
        }
      },
    });
  };

  createNewPassword = () => {
    const { email, verificationCode, password } = this.state;

    this.postWithData({
      url: `/rest/create_new_pass`,
      data: {
        email,
        code: verificationCode,
        password,
      },
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
            emailConfirmed: true,
            passwordConfirmed: true,
            verificationConfirmed: true,
          });
        }
      },
    });
  };

  backToEditEmail = () => {
    this.setState({
      emailConfirmed: false,
      verificationCode: '',
      verificationConfirmed: false,
    });
  };

  showHidePassword = () => {
    let input = document.getElementById('password-input');
    if (input.getAttribute('type') === 'password') {
      input.setAttribute('type', 'text');
      this.setState({ passwordVisible: true });
    } else {
      input.setAttribute('type', 'password');
      this.setState({ passwordVisible: false });
    }
    return false;
  };

  render() {
    const { classes, newSetupCreation, backToMainAuthWindow } = this.props;
    const {
      loading,
      email,
      message,
      password,
      emailConfirmed,
      passwordVisible,
      verificationCode,
      passwordConfirmed,
      verificationConfirmed,
    } = this.state;

    const currentSubmitAction =
      newSetupCreation ? this.createAccountEmailSend
      : passwordConfirmed ? backToMainAuthWindow
      : verificationConfirmed ? this.createNewPassword
      : emailConfirmed ? this.checkVerificationCode : this.passwordRecoveryEmail;

    const backAction = (emailConfirmed && !verificationConfirmed) ? this.backToEditEmail : backToMainAuthWindow;

    return (
      <div>
        <div
          className={`${classes.dialogTitle}`}
          style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}
        >
          {newSetupCreation || (!newSetupCreation && !passwordConfirmed ) || (newSetupCreation && !emailConfirmed) ?
            <ArrowBackIosNewOutlinedIcon
              id='back-icon'
              className={classes.backIcon}
              onClick={() => {
                backAction();
              }}
            />
          : null}
          <div style={{ marginLeft: '-20px', display: 'flex', width: '100%', justifyContent: 'space-around', paddingBottom: '2px' }}>
            {newSetupCreation && !emailConfirmed ? <div>{'Enter your Email'}</div>
            : !newSetupCreation && !emailConfirmed ? <div>{'Enter your registered Email'}</div>
            : !newSetupCreation && !verificationConfirmed ? <div>{'Check your Email'}</div>
            : !newSetupCreation && !passwordConfirmed ? <div>{'Create new password'}</div>
            : <div style={{ display: 'inherit' }}><CheckOutlinedIcon style={{ color: '#1EB923', marginRight: '10px' }}/>Success</div>}
          </div>
        </div>

        {newSetupCreation && emailConfirmed ?
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className={classes.messageBlock}>
            <div className={classes.messageTitle} style={{alignSelf: 'center'}} dangerouslySetInnerHTML={{ __html: message }} />
            <div style={{fontSize: 40, alignSelf: 'center'}}> {emojiesSuccess[Math.floor(Math.random() * emojiesSuccess.length)]} </div>
          </div>
        </div>
        : passwordConfirmed ?
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: 14, marginTop: '-20px', marginBottom: '20px' }}>
              {'Your password has been reset'}
            </span>
            <div style={{ fontSize: 40 }}> {emojiesSuccess[Math.floor(Math.random() * emojiesSuccess.length)]} </div>
          </div>
        : verificationConfirmed ?
          <div>
            <div style={{ paddingBottom: '7px' }}>
              <span>
                {'Your new password'}
              </span>
            </div>
            <div style={{ display: 'inline-flex', justifyContent: 'flex-end', width: '-webkit-fill-available' }}>
              <input
                autoFocus
                type='text'
                id='password-input'
                className={`${classes.insetShadowInput}`}
                onChange={(e) => this.setState({ password: e.target.value }) }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && password.length) this.createNewPassword();
                }}
              />
              <div style={{ position: 'absolute', margin: '8px' }} onClick={this.showHidePassword}>
                {passwordVisible ?
                  <VisibilityOffOutlinedIcon className={classes.backIcon}/>
                  : <VisibilityOutlinedIcon className={classes.backIcon}/>
                }
              </div>
            </div>
          </div>
        : emailConfirmed && !newSetupCreation ?
          <React.Fragment>
            <div className={classes.mb20}>
              <div style={{ paddingBottom: '7px' }}>
                <span>
                  {'Verification code was sent to'}
                </span>
              </div>
              <span style={{ fontWeight: 'bold' }}>
                {email}
              </span>
            </div>
            <div>
              <div style={{ paddingBottom: '7px' }}>
                <span>
                  {'Verification code'}
                </span>
              </div>
              <input
                autoFocus
                type={'number'}
                className={`${classes.insetShadowInput}`}
                onChange={(e) => this.setState({ verificationCode: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && verificationCode.length) this.checkVerificationCode();
                }}
              />
            </div>
          </React.Fragment>
        :
          <div>
            <div style={{ paddingBottom: '7px' }}>
              <span>
                {'Your email'}
              </span>
            </div>
            <input
              autoFocus
              label='Email'
              value={email || ''}
              placeholder="email@example.com"
              className={`${classes.insetShadowInput}`}
              onChange={(e) => this.setState({ email: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && email.length) newSetupCreation ? this.createAccountEmailSend() : this.passwordRecoveryEmail();
              }}
            />
          </div>
        }

        {newSetupCreation && emailConfirmed ? null :
          <div>
            <Button
              autoFocus 
              disabled={email === '' || loading}
              disableElevation
              size="small"
              variant="contained"
              className={`${classes.okBtn} ${classes.mt20}`}
              onClick={() => {
                this.setState({
                  loading: true
                },
                () => {
                  currentSubmitAction();
                });
              }}
              >
              {loading ? <LoaderNew color='white'/> : passwordConfirmed ? 'Continue' : verificationConfirmed ? 'Reset password' : 'Next'}
            </Button>
          </div>
        }
      </div>
    );
  }
};

export default (PasswordRecoverAndAccountCreate);
